// src/components/icons/SiameseAILogoIcon.jsx

import React from 'react';
import styles from './SiameseAILogoIcon.module.css';
import siameseAILogo from '../assets/siameseAI_logo.svg';

function SiameseAILogoIcon({ className, onClick, title }) {
  return (
    <img
      src={siameseAILogo}
      alt="Siamese Logo"
      className={`${styles.siameseLogo} ${className || ''}`}
      onClick={onClick}
      title={title}
    />
  );
}

export default SiameseAILogoIcon;

